import sanitizeHtml from 'sanitize-html';
import OptionsDots from "../../components/Icons/OptionsDots";
import { debounce, updateVideoQuality } from "../../features/base/video-quality/actions";
import { CONV_STORAGE,spacesView, kinoParticipants, permissions, room, Video, volumeManager, lockFocus, cameraOptionsPreferences, isCameraMuted, onStage, buttonSpam, getKinoRole, isMicMuted } from "../../libs/roomnew";
import { getPendingMovesForSpace } from './pendingMoves';

import { adjustSlider } from "../functions";
import { isEndpointVisible, setSpaceMenuVisibleEndpoints, setSpacesLobbyViewVisibleEndpoints } from '../../features/base/video-quality/functions';

export default class NewSpaceView{
    constructor(){
        //variables
        this.expandView             = $('#expandView');
        this.collapseView = $("#closeExpandedViewBtn");
        this.title                  = 'Spaces View';
        this.subTitle               = 'Double click a space to join';
        this.spacesPanel = $('#side-spaces-drawer');
        this.lobbyContainer = $("#expanedViewLobbyContainerId");
        this.spacesContainer = $("#expanedViewSpacesContainerId");
        this.lobbyTiles = $("#spaces-view-lobby-tiles");
        this.searchInput = $("#searchBarInput");
        this.searchBarInputExpandedView = $("#searchBarInputExpandedView")
        this.addSpacesButton = $("#spacesview-add-spaces");
        this.leftSpaceMenu = $("#left-space-menu");
        this.leftSpaceMenuOptions = $("#left-space-options");
        this.chatterBtn = $("#chatterBtnId");
        this.lobbySpaceContainer = $("#lobby-space-box")
        this.lobbyContainerBody = $("#lobby-space-body")
        this.dropDownSpaceMenu = $("#dropDownSpaceMenu")
        this.dropDownBody = $("#drop-down-menu-body")
        this.participantsListMenu = $("#searchParticipantResultId")
        this.spacesPanelScrollable = $("#spacesPanelScrollable")
        this.closeIconDropDownLobby = $("#closeIconDropDownLobby")
        this.enterSpaceMenuButtoDropDown = $("#enterBtnLeftSide")
        this.dropDownSpaceMenuName = $("dropDownSpaceMenuName")
        this.backButton = $("#backButton")
        this.backButtonExpandedView = $("#backButtonExpandedView")
        this.clearSearch = $("#clearSearch")
        this.clearSearchExpandedView = $("#clearSearchExpandedView")
        this.allSpaces = []
        this.participantCount = 1;
        //states
        this.isExpanded              = false;

        //icons
        this.lobbyIcon              = `<svg class="lobby-icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.34442 1.24523C9.24457 1.16732 9.12156 1.125 8.99491 1.125C8.86826 1.125 8.74525 1.16732 8.6454 1.24523L0.5625 7.54838L1.26152 8.43246L2.25 7.66172V14.625C2.25061 14.9231 2.36933 15.2089 2.58018 15.4198C2.79102 15.6306 3.07682 15.7494 3.375 15.75H14.625C14.9232 15.7494 15.209 15.6307 15.4199 15.4199C15.6307 15.209 15.7494 14.9232 15.75 14.625V7.66684L16.7385 8.43747L17.4375 7.55333L9.34442 1.24523ZM10.125 14.625H7.875V10.125H10.125V14.625ZM11.25 14.625V10.125C11.2497 9.8267 11.131 9.54076 10.9201 9.32985C10.7092 9.11895 10.4233 9.00031 10.125 8.99997H7.875C7.57672 9.00027 7.29075 9.11889 7.07983 9.3298C6.86892 9.54072 6.7503 9.82669 6.75 10.125V14.625H3.375V6.78456L9 2.40269L14.625 6.79047V14.625H11.25Z" fill="white"/></svg>`;
        this.pinIcon              = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle r="10" transform="matrix(-1 0 0 1 10 10)" fill="#C4C4C4" fill-opacity="0.3"/><path d="M15.7961 8.63728L16.459 7.97461L11.7715 3.33398L11.1555 3.99727L11.7113 4.55306L6.32461 9.11016L5.52028 8.30587L4.85742 8.95898L7.50923 11.6202L3.33398 15.7948L3.99492 16.459L8.172 12.283L10.834 14.9347L11.4869 14.2719L10.6823 13.4674L15.2405 8.08172L15.7961 8.63728Z" fill="white"/></svg>`;
        this.unpinIcon              = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20Z" fill="#C4C4C4" fill-opacity="0.3"/>
        <path d="M15.7961 8.63728L16.459 7.97461L11.7715 3.33398L11.1555 3.99727L11.7113 4.55306L6.32461 9.11016L5.52028 8.30587L4.85742 8.95898L7.50923 11.6202L3.33398 15.7948L3.99492 16.459L8.172 12.283L10.834 14.9347L11.4869 14.2719L10.6823 13.4674L15.2405 8.08172L15.7961 8.63728Z" fill="white"/>
        <path d="M4.58459 4.13492L15.8775 15.4278" stroke="white" stroke-linecap="round"/>
        </svg>
        `;
        this.editIcon               = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle r="10" transform="matrix(-1 0 0 1 10 10)" fill="#C4C4C4" fill-opacity="0.3"/><path d="M3.33398 13.725V16.459H6.06798L14.1314 8.39552L11.3974 5.66153L3.33398 13.725ZM16.2457 6.28123C16.5301 5.9969 16.5301 5.53758 16.2457 5.25325L14.5397 3.54724C14.2554 3.2629 13.7961 3.2629 13.5117 3.54724L12.1775 4.88143L14.9115 7.61542L16.2457 6.28123Z" fill="white"/></svg>`;
        // this.spacesViewIcon = `<svg width="30px" height="30px" viewBox="0 0 48 48" class="change-view-icon"><g id="grid"><path d="M0 0L48 0L48 48L0 48L0 0Z" id="Background" fill="none" stroke="none"></path><path d="M8 10C9.104 10 10 9.104 10 8L10 2C10 0.896 9.104 0 8 0L2 0C0.896 0 0 0.896 0 2L0 8C0 9.104 0.896 10 2 10L8 10ZM23 8C23 9.104 22.104 10 21 10L15 10C13.896 10 13 9.104 13 8L13 2C13 0.896 13.896 0 15 0L21 0C22.104 0 23 0.896 23 2L23 8ZM34 10C35.104 10 36 9.104 36 8L36 2C36 0.896 35.104 0 34 0L28 0C26.896 0 26 0.896 26 2L26 8C26 9.104 26.896 10 28 10L34 10ZM10 21C10 22.104 9.104 23 8 23L2 23C0.896 23 0 22.104 0 21L0 15C0 13.896 0.896 13 2 13L8 13C9.104 13 10 13.896 10 15L10 21ZM21 23C22.104 23 23 22.104 23 21L23 15C23 13.896 22.104 13 21 13L15 13C13.896 13 13 13.896 13 15L13 21C13 22.104 13.896 23 15 23L21 23ZM36 21C36 22.104 35.104 23 34 23L28 23C26.896 23 26 22.104 26 21L26 15C26 13.896 26.896 13 28 13L34 13C35.104 13 36 13.896 36 15L36 21ZM8 36C9.104 36 10 35.104 10 34L10 28C10 26.896 9.104 26 8 26L2 26C0.896 26 0 26.896 0 28L0 34C0 35.104 0.896 36 2 36L8 36ZM23 34C23 35.104 22.104 36 21 36L15 36C13.896 36 13 35.104 13 34L13 28C13 26.896 13.896 26 15 26L21 26C22.104 26 23 26.896 23 28L23 34ZM34 36C35.104 36 36 35.104 36 34L36 28C36 26.896 35.104 26 34 26L28 26C26.896 26 26 26.896 26 28L26 34C26 35.104 26.896 36 28 36L34 36Z" transform="translate(6 6)" id="Shape" fill-rule="evenodd" stroke="none"></path></g></svg>`;
        this.spacesViewIcon=`<svg class="bi bi-grid" fill="currentColor" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zM2.5 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zM1 10.5A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z"></path></svg>`;
        this.spaceTileWidth = 0;
        this.alreadySentResolutions=[];
        this.disabled=false;

        this.maxTilesCollapsed = 2;
        this.maxTilesExpanded = 2;
        this.lobbyMaxTilesExpanded=10;

        this.windowHeight = window.innerHeight

        this.lobbycontainerHight = this.lobbyContainerBody.height()

        this.spaceWidth = this.getCalculatedSpacesPanelWidth();
        this.spaceMargin = 40;
        this.dropDownMenu = $("#dropDownMenu");
        this.doubleClickOccurred = false
        this.oneClickOccurre = false;
        this.volume = 0.05;
        this.lastVolume = 1; //lounge volume
        this.enterSpaceMenuButton = $("#enterSpaceMenuButton")
        this.sanitizeOptions = {
            allowedTags: [],
            allowedAttributes: {
                span: [],
                img: [],
            },
            allowedSchemesByTag: {
                img: [],
            },
        };
        this.micMutedIcon = `<svg width="15px" height="15px" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M265.403 88.2228C264.31 53.2236 235.217 25.0055 199.999 25.0055C163.906 25.0055 134.375 54.536 134.375 90.6289V200.001C134.375 205.907 135.25 211.376 136.781 216.845L265.403 88.2228Z" fill="#FF3D00"/>
        <path d="M199.999 265.625C236.092 265.625 265.622 236.094 265.622 200.001V149.843L371.801 43.6644C376.066 39.3989 376.066 32.4647 371.801 28.1991C367.535 23.9336 360.601 23.9336 356.336 28.1991L28.2183 356.316C23.9309 360.582 23.9309 367.516 28.1964 371.782C32.4619 376.069 39.3743 376.069 43.6617 371.804L131.335 284.131C147.565 297.19 167.253 306.049 189.061 308.28V364.06C189.061 370.185 193.874 374.997 199.999 374.997C206.123 374.997 210.936 370.185 210.936 364.06V308.28C266.06 302.593 309.371 256.656 309.371 200.001V189.064C309.371 182.939 304.559 178.127 298.434 178.127C292.309 178.127 287.497 182.939 287.497 189.064V200.001C287.497 248.344 248.341 287.499 199.999 287.499C179.874 287.499 161.5 280.324 146.603 268.862L162.112 253.353C172.852 260.987 185.977 265.625 199.999 265.625V265.625Z" fill="#FF3D00"/>
        <path d="M119.501 234.126C114.907 223.626 112.501 212.032 112.501 200.001V189.064C112.501 182.939 107.688 178.127 101.563 178.127C95.4386 178.127 90.6262 182.939 90.6262 189.064V200.001C90.6262 218.376 95.2199 235.438 103.095 250.531L119.501 234.126Z" fill="#FF3D00"/>
        </svg>`;
        this.cameraMutedIcon = `<svg width="15px" height="15px" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M46.4372 307.202L262.121 91.5075C259.715 90.8513 257.309 90.6325 254.684 90.6325H57.812C39.656 90.6325 25 105.289 25 123.446V276.576C25 290.795 33.9686 302.827 46.4372 307.202Z" fill="#FF3D00"></path><path d="M359.245 113.602L287.496 149.478V127.974L371.801 43.6654C376.066 39.3997 376.066 32.4651 371.801 28.1993C367.535 23.9336 360.601 23.9336 356.335 28.1993L28.2156 356.335C23.95 360.6 23.95 367.535 28.2156 371.801C32.4811 376.066 39.4154 376.066 43.6809 371.801L106.089 309.389H254.684C272.84 309.389 287.496 294.733 287.496 276.576V250.544L359.245 286.42C363.292 288.148 367.032 287.689 369.745 285.982C373.026 283.795 374.995 280.295 374.995 276.576V123.446C374.995 119.727 373.026 116.227 369.745 114.04C366.682 112.071 362.526 111.852 359.245 113.602V113.602Z" fill="#FF3D00"></path></svg>`
        this.pinnedSpacesOrderStart = 2;
        this.nonPinnedSpacesOrderStart = 100;
        this.expandedOpenedMenu=null;
    }
    events(){
        var app = this;
        this.expandView.on('click',()=>{
            this.toggleExpandView();
        })
        this.collapseView.on('click',()=>{
            this.deactivateTheSearchViewExpanded()
            this.toggleExpandView();
            this.closeDropDownMenu()
            $(".drop-down-space-menu").addClass("d-none")
            // this.setLobbyHeight()
        })

        this.addSpaceEvent();
        this.renderVolumeSlider();

        let clickTimeout;

        $("#lobby-space-body").on('click', () => {
            if (clickTimeout) {
                clearTimeout(clickTimeout);
                clickTimeout = null;
                if(CONV_STORAGE.myConversation){
                    spacesView.hideSpaceView();
                    if(onStage.isActive()){
                        onStage.showLockOnStageActiveNotification();
                        return;
                    }
                    if(lockFocus.isLocked() && !permissions.hasSpacesLock()){
                        lockFocus.showLockFocusNotification();
                        return;
                    }

                    CONV_STORAGE.leaveSpace();
                }
            } else {
                clickTimeout = setTimeout(() => {
                    // This is a single click
                    clickTimeout = null;
                    if ($("#side-spaces-drawer").hasClass("spaces-panel-expanded")) {
                        this.openDropDownMenu()
                    } else {
                        this.toggleLeftMenu()
                    }
                }, 500); // Adjust the timeout duration as needed
            }
            $("#removeButton").html("")
        });

        $("#left-menu-lobby").on('click',()=>{
        if($("#side-spaces-drawer").hasClass("spaces-panel-expanded")){
        } else {
            this.toggleLeftMenu();
        }
        })
        this.updateSpacesHeight();

        $("#closeIconDropDownLobby").on("click", (e) => {
            e.stopPropagation()
            this.closeDropDownMenu()
        })

        this.enterSpaceMenuButtoDropDown.on("click", (e) => {
            e.stopPropagation()
            if(CONV_STORAGE.myConversation){
                CONV_STORAGE.leaveSpace()
            }
            $(".drop-down-space-menu").addClass("d-none")
        })

        app.searchInput.on("input", function(){
            let input = '';
            input = $(this).val().toLowerCase();
            if(input === ""){
                app.clearSearch.addClass("d-none")
                app.deactivateTheSearchView()
            } else {
                app.clearSearch.removeClass("d-none")
                app.searchFunction(input)
            }
        }).on("click",function(){
            let input = '';
            input = $(this).val().toLowerCase();
            if(input.length == 0){
                app.showAllSpacesInList()
            }else {
                app.searchFunction(input)
            }
        }).on("focus", () => {
            app.searchInput.removeAttr("placeholder")
        }).on("blur",  () => {
            app.searchInput.attr("placeholder", "Search Names")
        })

        app.searchBarInputExpandedView.on("click", function(){
            let input = '';
            input = $(this).val().toLowerCase();
            if(input.length == 0){
                app.showAllSpacesInList()
            }else {
                app.searchFunction(input)
            }
        }).on("input", function(){
            let input = '';
            input = $(this).val().toLowerCase();
            if(input === ""){
                app.clearSearchExpandedView.addClass("d-none")
                app.deactivateTheSearchViewExpanded()
            } else {
                app.clearSearchExpandedView.removeClass("d-none")
                app.searchFunction(input)
            }
        }).on("focus", () => {
            app.searchBarInputExpandedView.removeAttr("placeholder")
        }).on("blur",  () => {
            app.searchBarInputExpandedView.attr("placeholder", "Search Names")
        })

        app.backButton.on("click", () => {
            app.deactivateTheSearchView()
        })

        app.backButtonExpandedView.on("click", () => {
            app.deactivateTheSearchViewExpanded()
        })

        app.clearSearch.on("click", () => {
            app.searchInput.val("")
            app.clearSearch.addClass("d-none")
            app.showAllSpacesInList()
        })

        app.clearSearchExpandedView.on("click", () => {
            app.searchBarInputExpandedView.val("")
            app.clearSearchExpandedView.addClass("d-none")
            app.showAllSpacesInList()
        })

        $("#closingLeftSideMenu").on("click", () => {
            this.closeLeftSpaceMenu()
        })

        $("#lobby-chatter-btn").on('click',()=>{
            if(this.isChatterLocked()){
                return
            }
            if(this.volume===0){
                this.unMute()
            }else{
                this.setVolume(0)
            }
        })

        this.addSpacesButton.on("mouseover", () => {
            if (!permissions.hasSpacesManager()) {
                this.addSpacesButton.attr("data-original-title", "You don't have permissions to add spaces");
                this.addSpacesButton.attr("data-placement", "top");
                this.addSpacesButton.attr("title", "");
                this.addSpacesButton.attr("data-toggle", "tooltip");
            } else {
                // Remove attributes when in the else block
                this.addSpacesButton.removeAttr("data-original-title");
                this.addSpacesButton.removeAttr("data-placement");
                this.addSpacesButton.removeAttr("title");
                this.addSpacesButton.removeAttr("data-toggle");
            }
        });

        $("#spacesPanelScrollable").on('scroll',Video.efss.inViewPortConversations.bind(Video.efss, true));
        $("#expanedViewSpacesContainerId").on('scroll',Video.efss.inViewPortConversations.bind(Video.efss, true));
        $("#left-menu-participants").on('scroll',Video.efss.inViewportSpaceMenu.bind(Video.efss, true));
        $("#lobby-space-body").on('scroll',Video.efss.inViewportLobby.bind(Video.efss, true));
    }

    isOpen(){
        return this.spacesPanel.hasClass('spaces-panel-expanded');
    }


    calculateLobbyHeight(){
        if(this.isOpen()){
            const availableHeight = window.innerHeight - 250;
            let test1 = parseInt(availableHeight / this.getTileHeight());
            this.participantContainerHeight = $(".participant-video-container").height() + 2;
            this.numberOfParticipantsCanBeDisplayed = test1
            this.lobbycontainerHight = (this.getTileHeight() * Math.ceil(this.numberOfParticipantsCanBeDisplayed/2))
            this.lobbyTiles.css({
                'height':this.lobbycontainerHight+"px",
                'width' :this.spaceWidth+"px"
            })
            this.lobbyContainer.css({width:this.getSpaceTileWidth()+"px"})
        }else{
            this.lobbyTiles.css({
                'height':this.getTileHeight()+"px",
                'width' :this.spaceWidth+"px"
            })
            this.lobbyContainer.css({width:"unset"})
        }

        this.lobbyTiles.find('.participant-video-container').css({
            'width':this.getTileWidth()+"px",
            'height':this.getTileHeight()+"px"
        })

        // const lobbySpaceBody = document.getElementById('lobby-space-body');
        // this.isOpen() ? lobbySpaceBody.style.height = this.lobbycontainerHight + 'px' : lobbySpaceBody.style.height = 77 + 'px'
    }

    getSpaceTileHeight(){
        return {
            min: this.getTileHeight() + this.getSpaceHeightOffset(),
            max: this.getTileHeight() + this.getSpaceHeightOffset()
        };
    };

    getSpaceTileWidth(){
        return this.spaceWidth + (this.isOpen() ? 28.5 : 0);
    }

    getSpaceHeightOffset(){
        let offset = 62;
        if(window.innerHeight <= 800){
            offset = 37;
        }
        return offset
    }

    getTileHeightOffset(){
        let offset = 15;
        if(window.innerHeight <= 800){
            offset = 15;
        }
        return offset
    }

    getCollapsedPanelWidth(){
        let padding = 32;
        let width = 248;
        if(window.innerHeight <= 800){
            width = 216;
            padding = 16;
        }
        return width - padding
    }

    getTileWidth(){
        return (this.spaceWidth / 2) - 1
    }

    getTileHeight(){
        return Math.max(60,this.getTileWidth() - this.getTileHeightOffset());
    }

    getLobbyContainerHight(){
        return {
            height: this.lobbycontainerHight
        }
    }
    updateSpacesHeight(){
        try {
            this.calculateTileWidth();
            this.calculateLobbyHeight();

            let tileHeight=this.getSpaceTileHeight();

            this.lobbySpaceContainer.css({
                'width': this.spaceWidth+"px"
            });

            this.spacesContainer.find('.space-panel-box').each((i,space)=>{
                $(space).find('.lobby-tiles').css({
                    'width':this.spaceWidth+"px",
                    'min-height':this.getTileHeight()+"px",
                    'max-height':this.getTileHeight()+"px"
                })
                $(space).find('.participant-video-container').css({
                    'width':this.getTileWidth()+"px",
                    'height':this.getTileHeight()+"px"
                })
                $(space).css({
                    'width':this.getSpaceTileWidth()+'px',
                    'min-height':tileHeight.min+"px",
                    'max-height':tileHeight.max+"px"
                });
            });
            $(".search-participant-result .body-layout-conatiner").css(
                "min-height",
                this.getTileHeight() + "px"
            );
        } catch (error) {
            console.error(error)
        }
    };

    getCalculatedSpacesPanelWidth(){
        const totalWidth = Math.min(1250,window.innerWidth);
        const padding = 32;
        const columns = totalWidth <= 768 ? 3 : 4;
        return (totalWidth / columns) - padding
    }

    calculateTileWidth(){
        this.spaceWidth=this.isOpen() ? this.getCalculatedSpacesPanelWidth() : this.getCollapsedPanelWidth();
        console.log(`Calculate space tile width from container ${this.spaceWidth}`);
    };

    toggleExpandView() {
        if (this.isOpen()) {
            this.hideSpaceView();
        } else {
            this.showSpaceView();
        }
        // this.updateSpacesHeight();
    }

    showSpaceView(){
        if(this.disabled){
            return;
        }
        this.isSpaceOpen = true;
        this.spacesPanel.addClass('spaces-panel-expanded');
        this.lobbyContainer.addClass('col-md-3')
        this.spacesContainer.addClass("col-md-9 spaces-section");
        $("#spacesPanelScrollable").addClass("d-flex flex-row");
        $("#spacesPanelActionId").removeClass("justify-content-between").addClass('pl-3')
        this.chatterBtn.addClass("ml-2")
        this.onSpacesPanelOpen();
        this.closeLeftSpaceMenu()
    }

    hideSpaceView(){
        if(!this.isOpen()){
            return
        }
        this.isSpaceOpen = false;
        this.spacesPanel.removeClass('spaces-panel-expanded');
            setTimeout(() => {
                this.lobbyContainer.removeClass('col-md-3')
                this.spacesContainer.removeClass("col-md-9 spaces-section")
                $("#spacesPanelScrollable").removeClass("d-flex flex-row");
                $("#spacesPanelActionId").addClass("justify-content-between").removeClass('pl-3')
                this.chatterBtn.removeClass("ml-2")
            }, 400);
        this.onSpacesPanelClosed();
        this.closeDropDownMenu()
    }


    renderSpacesContainer(){
        let sv = this;

        //add spaces button


        //space section container
        sv.spacesSection = $('<div/>',{
            class: 'spaces-container',
            html: []
        })

        sv.focusedSpacesSection = $('<div/>',{
            class: 'spaces-container',
            html: []
        })

        sv.spacesContainer = $('<div/>',{
            class: 'spaces-section col-md-9',
            id: "spaces-scrollable",
            html: [sv.spacesSection, sv.focusedSpacesSection]
        })

        sv.spacesRow.html(sv.spacesContainer);
        sv.calculateTileWidth();
        // if(this.isMod()){
        //     this.addModAccess();
        // }
    }

    addSpaceEvent(){
        this.addSpacesButton.on('click', ()=>{
            if(buttonSpam.isSpam('spacesview-add-spaces',true,500)){
                return
            }
            if(!permissions.hasSpacesManager()){
                return
            }
            this.createNewSpace();
        })
    };

    updateNoCameraLayerThumbnail(participant,cameraOn){
        if(!participant){return}
        if(!isEndpointVisible(participant.id)){return}
        const spaceId = participant.getSpaceId()
        if(CONV_STORAGE.conversations[spaceId]){
            const camerathumb = CONV_STORAGE.conversations[spaceId].tiles.find(`.pid_${participant.id} no-camera-spaces-thumb`);
            if(camerathumb){
                cameraOn && camerathumb.addClass('d-none')
                cameraOn || camerathumb.removeClass('d-none')
            }

        }else {
            const camerathumb = this.lobbyTiles.find(`.pid_${participant.id} no-camera-spaces-thumb`);
            if(camerathumb){
                cameraOn && camerathumb.addClass('d-none')
                cameraOn || camerathumb.removeClass('d-none')
            }
        }
    }

    addModAccess() {
        var c = this;
        console.log("adding mod access");
        // c.spacesSection.addClass("moderator");
        // c.createAddSpaceBox();

        // $.each(CONV_STORAGE.conversations, (i)=>{
        //     if (CONV_STORAGE.conversations[i]) {
        //         CONV_STORAGE.conversations[i].addOrUpdatePinAccess();
        //     }
        // });
    };

    removeModAccess(){
        try {
            if(this.addSpaceButtonContainer){
                this.addSpaceButtonContainer.remove();
                this.addSpaceButtonContainer=null;
            }
            this.spacesSection.removeClass("moderator");
        } catch (error) { console.error("[Kino Error] [NewSpacesView]", error); }
    };

    renderAddSpaceBox(){
        // if(permissions.hasSpacesManager()){
        //     this.addModAccess();
        // }else{
        //     this.removeModAccess();
        // }
    }

    addPinnedSpace(){
        let sv = this;
        sv.pinnedSpace = $('<span/>',{
            class: 'pinned-space-icon',
            html: sv.unpinIcon
        })
        sv.space = $('<div/>',{
            class: 'space',
            html: [sv.pinnedSpace]
        })
        sv.spaceName = $('<spam/>',{
            class: 'spaces-name',
            html: 'Viktor\'s Space'
        })
        sv.spaceControls = $('<div/>',{
            class: 'spaces-name-icon',
            html: [sv.spaceName]
        })
        sv.newPinnedSpace = $('<div/>',{
            class: 'col-4 spaces-div',
            html: [sv.spaceControls, sv.space]
        })
        sv.addPinActions();
        sv.spacesSection.append(sv.newPinnedSpace);
        sv.addParticipantTile();
        sv.addParticipantTileToLobby();
    }

    addPinActions(){
        let sv = this;
        sv.pinAction = $('<button/>',{
            class: 'unpin-button',
            html: sv.unpinIcon
        }).on('click', function(){

        })

        sv.editAction = $('<button/>',{
            class: 'rename-button',
            html: sv.editIcon
        }).on('click', function(){

        })

        sv.modActions = $('<div/>',{
            class: 'mod-space-actions',
            html: [sv.pinAction, sv.editAction]
        })
        sv.spaceControls.prepend(sv.modActions)
    }

    // TESTING
    addParticipantTile(){
        let sv = this;


        sv.participantName = $('<span/>',{
            class: 'participant-name ellipsis',
            html: 'random Name'
        })
        sv.videoContainer = $('<div/>',{
            class: 'videoContainer',
            html:[sv.participantName]
        })
        sv.participantVideoContainer = $('<div/>',{
            class: 'participant-video-container',
            html: [sv.videoContainer]
        })

        sv.space.append(sv.participantVideoContainer);
    }
    // TESTING
    addParticipantTileToLobby(){
        let sv = this;
        let participantNameLobby = $('<span/>',{
            class: 'participant-name ellipsis',
            html: 'random Name'
        });
        let overlay=$("<div/>",{
            class:"participant-thumbnail-overlay"
        });
        let videoPlayer=document.createElement('video');
        let thumbnailInnerContainer=$("<div/>",{
            class:"participant-thumbnail-inner",
            html:[videoPlayer,overlay]
        })
        let videoContainerLobby = $('<div/>',{
            class: 'videoContainer',
            html:[thumbnailInnerContainer,participantNameLobby]
        })
        let participantVideoContainerLobby = $('<div/>',{
            class: 'participant-video-container',
            html: [videoContainerLobby]
        })

        sv.lobbyTiles.append(participantVideoContainerLobby);
    }

    populateLobbyParticipants(){
        this.lobbyTiles.html('');
        this.renderLobbySpaceTiles();
    };

    async onSpacesPanelOpen(){
        // this.setToggleFocusedView();
        $("#localVideoContainer").css('display','none');
        // TODO
        // Video.efss.inViewPortConversations();
        // Video.efss.visibleLobby();
        this.updateSpacesHeight();
        this.renderAllSpaces();
        // this.setInSpaceThumbnailResolution();
        setTimeout(() => {
            Video.efss.inViewPortConversations(false);
            Video.efss.inViewportLobby(false);
        }, 500);
        updateVideoQuality();
    };

    renderAllSpaces(){
        this.renderLobbySpaceTiles();
        Object.values(CONV_STORAGE.conversations).forEach(space=>{
            try {
                space.renderSpaceTiles();
            } catch (error) { console.error("[Kino Error] [NewSpacesView]", error); }
        })
    }

    onSpacesPanelClosing(){

    };

    onSpacesPanelClosed(){
        // this.setToggleSpacesView();
        this.alreadySentResolutions=[];
        //TODO
        // Video.efss.clearInViewConversations();
        // Video.efss.clearVisibleOnLobby();
        // Video.setQuality();
        this.updateSpacesHeight();
        this.renderAllSpaces();
        Video.efss.inViewPortConversations(false);
        setSpacesLobbyViewVisibleEndpoints([]);
        updateVideoQuality()
        $("#localVideoContainer").css('display','block');
        Video.placeDockedLocalVideo();
        setTimeout(function () {
            Video.placeDockedLocalVideo();
        }, 500);
    };

    isMod(){
        return HOST == 1 || ROLE == "moderator";
    };

    setInSpaceThumbnailResolution(){
        if(room){
            // Video.setQuality();
            let receiverConstraints=room.rtc._receiverVideoConstraints;
            let currentConstraints=room.rtc._receiverVideoConstraints.constraints;
            let resconstraints={
                lastN: -1,
                selectedEndpoints: [],
                onStageEndpoints: [],
                defaultConstraints: { maxHeight: 0 },
                constraints: {}
           };
            console.log("Updating resolutions",receiverConstraints);
            let inSpacesView=[...new Set([...Video.efss.visibleOnConversation,...Video.efss.visibleOnLobby])];
            console.log("current visible participants is spaces",inSpacesView);

            if(inSpacesView.length){
                if(this.alreadySentResolutions.toString() != inSpacesView.toString()){
                    inSpacesView.forEach(pid=>{
                        currentConstraints[pid]={maxHeight:180};
                    });
                    this.alreadySentResolutions=inSpacesView;
                    resconstraints.constraints=currentConstraints;
                    console.log("setting new constraints",resconstraints);
                    room.setReceiverConstraints(resconstraints);
                    console.log("saved receiver constraints",room.rtc._receiverVideoConstraints)
                    setTimeout(() => {
                        if(this.isOpen()){
                            room.setReceiverVideoConstraint(180);
                        }
                    }, 3000);
                }else{
                    console.log("In space view resolution no change")
                }

            }
        }
    };

    disableSpacesView(){
        this.disabled=true;
        this.expandView.addClass("toggle-disabled");
        $("#expandViewPanelActionId")
        .attr('data-toggle','tooltip')
        .attr('data-placement','top')
        .attr('data-original-title','Spaces View is disabled when Stage View is active.')
        if(this.isOpen()){
            this.hideSpaceView();
        }
    }

    disableAddSpace(){
        $("#spacesview-add-spaces")
        .attr('data-toggle','tooltip')
        .attr('data-placement','top')
        .attr('data-original-title','Add Spaces is disabled when Stage View is active.')
        $("#spacesview-add-spaces").addClass("toggle-disabled")
    }

    adjustLobbyForStageView(){
        if($("#spacesPanelScrollable").hasClass("stage-view")){
            console.log("123 Ima klasa");
            $("#spacesPanelScrollable").removeClass("stage-view")
        }else {
            console.log("123 Nema klasa");
            $("#spacesPanelScrollable").addClass("stage-view")

        }
    }

    enableSpacesView(){
        this.disabled=false;
        this.expandView.removeClass("toggle-disabled");
        $("#expandViewPanelActionId").removeAttr('data-toggle data-placement data-original-title title');

    }

    enableAddSpace(){
        $("#spacesview-add-spaces").removeClass("toggle-disabled")
        $("#spacesview-add-spaces").removeAttr('data-toggle data-placement data-original-title title');
    }


    addEnterButtonInTheLeftSideMenu () {
        const enterButton = $("<button/>", {
            class: "btn btn-blur enter-btn",
            html: "Enter Space",
            id: "enterBtnLeftSide"
        }).on("click", () => {
            if($("#left-space-menu").attr("space-id") !== "lobby"){
                this.space.onJoinSpace()
            }else {
            if(CONV_STORAGE.myConversation){
                CONV_STORAGE.leaveSpace()
            }
            }
            this.closeLeftSpaceMenu()
        })

        $(".left-side-menu-enter-button").html(enterButton)
    }

    openLeftSpaceMenu(){
            this.closeLeftSpaceMenu();
            this.addEnterButtonInTheLeftSideMenu()
        // if (panelContainer.classList.contains('open')) {
            this.createLeftMenuOptions();
            this.renderLeftMenuParticipants();
            $("#left-space-menu").addClass('open').removeClass('d-none');
            $("#left-space-menu").attr('space-id','lobby');
            Video.efss.inViewportSpaceMenu(false);
            Video.placeDockedLocalVideo();
        // }
    }

    closeLeftSpaceMenu(){
        Video.hideParticipantTippyMenus();
        $("#left-space-menu").removeClass('open').addClass('d-none');
        $("#left-space-menu").removeAttr('space-id');
        setSpaceMenuVisibleEndpoints([]);
        Video.placeDockedLocalVideo();
    }

    closeAllDropDownMenu(){
        Video.hideParticipantTippyMenus();
        $(".drop-down-space-menu").addClass("d-none")
    }

    toggleLeftMenu(){
        if($("#side-spaces-drawer").hasClass("spaces-panel-expanded")){
        } else {
            console.log("left menu has class open",$("#left-space-menu"))
            if ($("#left-space-menu").hasClass('open') && $("#left-space-menu").attr('space-id') == 'lobby'){
                this.closeLeftSpaceMenu();
            }else{
                this.openLeftSpaceMenu();
            }
        }
    }


    renderLeftMenuParticipants(){
        const PARTICIPANTS=[];
        kinoParticipants.getLobby().forEach(p => {
            console.log("PARTICIPANT",p);
            const participant = $("<h6/>",{
                class:'text-white/95 mb-4 space-options-item ellipsis',
                html:p.getName()+`${p.local ? ' (me)':''}`
            })

            const participantThumbnail = $("<div/>", {
                class: "participant-video-container",
                html: this.renderMenuParticipantThumbnail(p)
            })

            const email = p.local ? localStorage.getItem("displayEmail") : p.email;
            const role = p.local ? getKinoRole(): p.role;
            const participantEmail = $("<h6/>", {
                class: "participant-information ellipsis",
                attr: {
                    "data-original-title": email,
                    "data-placement": "top",
                    "title": "",
                    "data-toggle": "tooltip"
                }
            });

            if (email) {
                participantEmail.html(`Email: <a target="_blank" href="mailto:${email}">${email}</a>`);
            } else {
                participantEmail.text("Email: No email");
            }

            const participantRole = $("<h6/>", {
                html: `Role: ${role}`,
                class: "participant-information participant-role"
            })


            const actions = $('<span/>',{
                class: "option-icon-container",
                html:  OptionsDots,
            })
            Video.attachParticipantMenuTippy(actions[0], p)
            let isCameraMutedOnTile = p.local ? isCameraMuted() : Video.videos[p.id].isVideoMuted()
            let isMicMutedOnTile = p.local ? isMicMuted() :  Video.videos[p.id].hasMicMuted


            let micMuted = $('<div/>', {
                class: `in-video-mic-muted mic-status-${p.local ? "local" :p.id} cursor-pointer ${isMicMutedOnTile || "d-none"}`,
                html: this.micMutedIcon
            })

            let cameraMuted = $('<div/>',{
                class: `in-video-camera-muted camera-status-${p.local ? "local" :p.id} cursor-pointer ${isCameraMutedOnTile || "d-none"}`,

                html: this.cameraMutedIcon
            });

            let indicatiors = $("<div/>", {
                class: "space-menu-tiles-indicators",
                html: [micMuted,cameraMuted]
            }
            )

            const participantItem = $("<div/>",{
                class:'d-flex justify-content-between align-self-center participant-in-this-space',
                html:[
                    participant,
                    indicatiors,
                    actions
                ]
            })

            const participantMenuContentContainer = $("<div/>", {
                html: [participantEmail, participantRole]
            })

            const participantItemContainer = $("<div/>", {
                class: "participant-item-conatiner",
                html:  [participantItem,participantMenuContentContainer]
            })

            const  menuContainer = $("<div/>", {
                class: "menu-container d-flex mb-4 p-0",
                html: [participantItemContainer, participantThumbnail]
            })

            PARTICIPANTS.push(menuContainer)
        })
        const noOneInsideOfThisSpace = $("<h6/>", {
            class: "no-participant-title",
            html: "Empty Space"
        })

        if(PARTICIPANTS.length){
            $("#left-menu-participants").html(PARTICIPANTS);
        }else {
            $("#left-menu-participants").html(noOneInsideOfThisSpace);
        }
    }


    createLeftMenuOptions(){
        $("#left-menu-space-name").html("Lounge")
        const ITEMS = [];
        const enterLeaveSpace = $("<h6/>",{
            class:`${!CONV_STORAGE.myConversation ? 'text-muted pointer-none' : 'text-white/95'} space-options-item mb-4`,
            html:`Enter Space`
        }).on('click', () => {
            if(!CONV_STORAGE.myConversation){
                return;
            }
            this.closeLeftSpaceMenu();
            if(lockFocus.isLocked() && !permissions.hasSpacesLock()) {
                CONV_STORAGE.isJoining=false;
                lockFocus.showLockFocusNotification();
                return;
            }
            if(CONV_STORAGE.myConversation){
                CONV_STORAGE.leaveSpace();
            }
        });

        ITEMS.push(enterLeaveSpace);


        //chatter menu item
        const chatterToggle = $("<h6/>",{
            class:'text-white/95 space-options-item mb-4',
            html:`${volumeManager.masterMuted == 0 ? 'Chatter On' : 'Chatter Off'}`
        }).on('click',()=>{
            volumeManager.toggleChatter();
            chatterToggle.html(`${volumeManager.masterMuted == 0 ? 'Chatter On' : 'Chatter Off'}`)
        });
        ITEMS.push(chatterToggle);
        $("#left-space-options").html(ITEMS);
    }

    openDropDownMenu(){
        $(".drop-down-space-menu").addClass("d-none")
        this.dropDownMenu.removeClass("d-none")
        this.createDropDownMenuOptions()
    }

    closeDropDownMenu(){
        Video.hideParticipantTippyMenus();
        this.dropDownMenu.addClass("d-none")
    }

    renderMenuParticipantThumbnail(participant){
        console.log(`Function: createSpaceThumbnail(participant:${participant.id},space_id:${this.id})`);

        // if(Video.isLobbyView && participant.conversation_id!=c.myConversation && (participant.participant != room.myUserId() || room==null)){
        //     Video.speaker.removeSpeaker(participant.participant);
        //     Video.removeParticipantFromLobby(participant.participant);
        // }
        // this.removeLobbyThumbnail();
        let videoElement=document.createElement('video');
        videoElement.autoplay=1;
        videoElement.muted=1;
        videoElement.setAttribute('pid',participant.id);
        videoElement.classList.add('h-100','video-center','video-preview','conversation-video-player');
        if(participant.id == room.myUserId() && cameraOptionsPreferences.camera_flip){
            videoElement.classList.add('flipVideoX');
        }
        // if (participant.participant == room.myUserId()) {
        //     c.myConversation = participant.conversation_id;
        //     c.conversations[c.myConversation].htmlElement.addClass(
        //         "my-conversation"
        //     );
        // }
        let previewVideo = participant.getVideo();

        if (previewVideo) {
            videoElement.srcObject = previewVideo.stream;
            videoElement.oncanplay = function () {
                videoElement.play();
            };
        }

        let displayName = $('<div/>', {
            class: `participant-name ellipsis noselect display-name-${participant.id}`,
            html: participant.local ? participant.getName() + " (me)" : participant.getName()
        });
        let noCameraCirce=$('<div/>',{
            class: 'no-cam-layer-background mb-2',
            html: Video.noCameraIcon
        });
        participant.menuNoCameraLayerThumb=$("<div/>",{
            class:'no-camera-spaces-thumb d-none',
            html:[noCameraCirce]
        });

        let isCameraMutedOnTile = participant.local ? isCameraMuted() : Video.videos[participant.id].isVideoMuted()
        let isMicMutedOnTile = participant.local ? isMicMuted() :  Video.videos[participant.id].hasMicMuted

        let micMuted = $('<div/>', {
            class: `in-video-mic-muted mic-status-${participant.local ? "local" :participant.id} cursor-pointer ${isMicMutedOnTile || "d-none"}`,
            html: this.micMutedIcon
        })

        let cameraMuted = $('<div/>',{
            class: `in-video-camera-muted camera-status-${participant.local ? "local" :participant.id} cursor-pointer ${isCameraMutedOnTile || "d-none"}`,

            html: this.cameraMutedIcon
        });

        let indicatiors = $("<div/>", {
            class: "space-menu-tiles-indicators",
            html: [micMuted,cameraMuted]
        }
        )


        let vidcontainer = $("<div/>", {
            class: "videoContainer participant-container text-center",
            html: [videoElement,participant.menuNoCameraLayerThumb],
        });

        const spaceThumbnail = $("<div/>", {
            style: `height:${spacesView.getTileHeight()}px;width:${spacesView.getTileWidth()}px;`,
            class: `participant-video-container-dropw-down pid_${participant.id}`,
            'space-id': 'lobby',
            html: [vidcontainer],
        });
        // card id 906: make the lobby spaces-menu tile draggable into a space (reuses the
        // room DnD interactable registered in SplitConversations.initPanelDragDrop()).
        try {
            spaceThumbnail.attr('participant-id', participant.id);
            if (typeof permissions !== 'undefined' && permissions &&
                ((permissions.hasSpacesManager && permissions.hasSpacesManager()) ||
                 (permissions.hasDragDropSpaces && permissions.hasDragDropSpaces())) &&
                !(permissions.isLockedToSpace && permissions.isLockedToSpace())) {
                spaceThumbnail.addClass('kino-tile-draggable');
            }
        } catch (err) {
            console.warn('[Kino DragDrop] lobby menu tile tag failed', err);
        }
        //show no camera layer if video is muted
        if(Video.videos[participant.id]){
            if(Video.videos[participant.id].isVideoMuted()){
                Video.videos[participant.id].onVideoMuted();
            }
        }else if(participant.id==room.myUserId() && isCameraMuted()){
            participant.menuNoCameraLayerThumb.removeClass('d-none');
        }

        return spaceThumbnail
    }

    createDropDownMenuOptions(){
        const PARTICIPANTS=[];
        kinoParticipants.getLobby().forEach(p => {

            const participantThumbnail = $("<div/>", {
                class: "participant-video-container",
                html: this.renderMenuParticipantThumbnail(p)
            })

            const email = p.local ? localStorage.getItem("displayEmail") : p.email;
            const role = p.local ? getKinoRole(): p.role;
            const participantEmail = $("<h6/>", {
                class: "participant-information ellipsis",
                attr: {
                    "data-original-title": email,
                    "data-placement": "top",
                    "title": "",
                    "data-toggle": "tooltip"
                }
            });

            if (email) {
                participantEmail.html(`Email: <a target="_blank" href="mailto:${email}">${email}</a>`);
            } else {
                participantEmail.text("Email: No email");
            }

            const participantRole = $("<h6/>", {
                html: `Role: ${role}`,
                class: "participant-information participant-role"
            })

            const participant = $("<h6/>",{
                class:'text-white/95 mb-4 space-options-item ellipsis',
                html:p.getName()+`${p.local ? ' (me)':''}`
            })

            const actions = $('<span/>',{
                class: "option-icon-container",
                html:OptionsDots,
            })
            Video.attachParticipantMenuTippy(actions[0], p)

            let isCameraMutedOnTile = p.local ? isCameraMuted() : Video.videos[p.id].isVideoMuted()
            let isMicMutedOnTile = p.local ? isMicMuted() :  Video.videos[p.id].hasMicMuted


            let micMuted = $('<div/>', {
                class: `in-video-mic-muted mic-status-${p.local ? "local" :p.id} cursor-pointer ${isMicMutedOnTile || "d-none"}`,
                html: this.micMutedIcon
            })

            let cameraMuted = $('<div/>',{
                class: `in-video-camera-muted camera-status-${p.local ? "local" :p.id} cursor-pointer ${isCameraMutedOnTile || "d-none"}`,

                html: this.cameraMutedIcon
            });

            let indicatiors = $("<div/>", {
                class: "space-menu-tiles-indicators",
                html: [micMuted,cameraMuted]
            }
            )

            const participantItem = $("<div/>",{
                class:'d-flex justify-content-between align-self-center participant-in-this-space',
                html:[
                    participant,
                    indicatiors,
                    actions
                ]
            })
            const participantMenuContentContainer = $("<div/>", {
                html: [participantEmail, participantRole]
            })
            const participantItemContainer = $("<div/>", {
                class: "participant-item-conatiner col-md-8",
                html:  [participantItem,participantMenuContentContainer]
            })
            const  menuContainer = $("<div/>", {
                class: "menu-container d-flex mb-4 col-md-12 p-0",
                html: [participantItemContainer, participantThumbnail]
            })

            PARTICIPANTS.push(menuContainer)
        })
        const noOneInsideOfThisSpace = $("<h6/>", {
            class: "no-participant-title",
            html: "Empty Space"
        })
        if(PARTICIPANTS.length){
            $("#drop-down-menu-body").html(PARTICIPANTS);
        }else {
            $("#drop-down-menu-body").html(noOneInsideOfThisSpace);
        }
    }

    renderLobbySpaceTiles = debounce(()=>{
        const { incomingPids, outgoingPids } = getPendingMovesForSpace('lobby');
        // Suppress participants being dragged OUT of the lobby.
        const realPids = kinoParticipants.getLobby()
            .map(p => p.id)
            .filter(id => !outgoingPids.includes(String(id)));
        // Add participants being dragged INTO the lobby (still have a spaceId on the server side).
        const lobbyIds = kinoParticipants.getLobby().map(p => String(p.id));
        const incomingToAdd = incomingPids.filter(pid =>
            !lobbyIds.includes(String(pid)) && kinoParticipants.exists(pid)
        );
        const allEffectivePids = [...realPids, ...incomingToAdd];
        const effectiveCount = allEffectivePids.length;

        let visibleCount;
        if (this.isOpen()) {
            visibleCount = effectiveCount;
        } else {
            const maxTiles = this.isLobbyExpanded() ? 40 : this.maxTilesCollapsed;
            visibleCount = effectiveCount > maxTiles ? maxTiles - 1 : maxTiles;
        }
        console.log("isVisible",visibleCount);
        const firstPids = allEffectivePids.slice(0, visibleCount);
        const leftOut = allEffectivePids.slice(visibleCount);
        // console.error(`REnder lobby tiles, visible count ${visibleCount}`,allEffectivePids)
        this.lobbyTiles.html('');
        if(!CONV_STORAGE.myConversation){
            this.lobbySpaceContainer.addClass('my-space');
        }else{
            this.lobbySpaceContainer.removeClass('my-space');
        }
        firstPids.forEach((pid)=>{
            if (incomingToAdd.includes(pid)) {
                this._createPendingLobbyThumbnail(pid);
            } else {
                kinoParticipants.get(pid).createLobbyThumbnail();
            }
        })
        leftOut.forEach(pid=>{
            if (!incomingToAdd.includes(pid)) {
                kinoParticipants.get(pid).removeSpaceThumbnail();
            }
        })
        if(this.getHiddenCount() > 0 && !this.isOpen()){
            this.renderHiddenCountBox(this.getHiddenCount())
        }
    },200)

    _createPendingLobbyThumbnail(pid) {
        try {
            const p = kinoParticipants.get(pid);
            if (!p) return;

            let videoElement = document.createElement('video');
            videoElement.autoplay = 1;
            videoElement.muted = 1;
            videoElement.setAttribute('pid', pid);
            videoElement.classList.add('h-100', 'video-center', 'video-preview', 'conversation-video-player');

            let previewVideo = p.getVideo();
            if (previewVideo) {
                videoElement.srcObject = previewVideo.stream;
                videoElement.oncanplay = function () { videoElement.play(); };
            }

            let displayName = $('<div/>', {
                class: `participant-display-name ellipsis noselect display-name-${pid}`,
                html: p.getName()
            });
            let nameContainer = $('<div/>', {
                class: `participant-name ellipsis noselect display-name-${pid}`,
                html: [displayName]
            });

            let noCameraCircle = $('<div/>', {
                class: 'no-cam-layer-background mb-2',
                html: Video.noCameraIcon
            });
            let noCameraLayer = $('<div/>', {
                class: 'no-camera-spaces-thumb d-none',
                html: [noCameraCircle]
            });

            if (Video.videos[pid] && Video.videos[pid].isVideoMuted()) {
                noCameraLayer.removeClass('d-none');
            }

            let vidcontainer = $('<div/>', {
                class: 'videoContainer participant-container text-center',
                html: [nameContainer, videoElement, noCameraLayer]
            });

            let tile = $('<div/>', {
                style: `height:${this.getTileHeight()}px;width:${this.getTileWidth()}px;pointer-events:none;`,
                class: `participant-video-container pid_${pid} kino-pending-tile`,
                'space-id': 'lobby',
                html: [vidcontainer]
            });

            this.lobbyTiles.append(tile);
        } catch (e) {
            console.warn('[PendingMove] _createPendingLobbyThumbnail error', e);
        }
    }

    renderHiddenCountBox(count){
        const counter = $("<h5/>",{
            class:`text-white mb-0 space-hidden-counter-text`,
            html:'+'+count
        });
        if(this.hiddenCounter){
            this.hiddenCounter.remove();
        }
        this.hiddenCounter = $("<div/>",{
            class:'participant-video-container space-hidden-counter',
            style: `height:${this.getTileHeight()}px;width:${this.getTileWidth()}px;`,
            html:counter
        })
        this.lobbyTiles.append(this.hiddenCounter);
    }

    getVisibleCount(){
        const participants = kinoParticipants.getLobby().map(p=>p.id).length;
        console.log("isWindowSmall", this.isWindowSmall());
        if(this.isOpen() && !this.isWindowSmall()){
            if(participants  > this.lobbyMaxTilesExpanded){
                return this.lobbyMaxTilesExpanded - 1;
            }
            return this.lobbyMaxTilesExpanded
        }else{
            const maxTiles = this.isLobbyExpanded() ? 40 : this.maxTilesCollapsed;
            if(participants  > maxTiles){
                console.log("lobby max tiles ",maxTiles);
                return maxTiles - 1;
            }
            return maxTiles
        }
    }

    isWindowSmall() {
        return this.windowHeight <= 800
    }

    isLobbyExpanded() {
        return this.lobbyTiles.hasClass('full-height-space')
    }

    getHiddenCount(){
        const participants = kinoParticipants.getLobby().map(p=>p.id).length;
        if(this.isOpen() && !this.isWindowSmall()){
            if(participants  > this.maxTilesExpanded){
                return (participants - this.maxTilesCollapsed) + 1;
            }
        }else{
            const maxTiles = this.isLobbyExpanded() ? 40 : this.maxTilesCollapsed;
            if(participants  > maxTiles){
                return (participants - maxTiles) + 1;
            }
        }
        return 0
    }

    renderVolumeSlider(){
        this.volumePercentage = $("<span/>",{
            class:"volume-percentage-text",
            html:"100%"
        })

        this.runnable = $("<span/>",{
            class:'slider-runnable'
        });
        adjustSlider(this.runnable[0],1);
        this.volumeSlider = $("<input/>",{
            id:'sideBarVolumeRange',
            type:"range",
            min:"0",
            max:"1",
            value:"1",
            step:"0.01"
        }).on('input',()=>{
            if(this.isChatterLocked() || this.isOtherSpacesVolumeLocked()){
                return
            }
            this.setVolume(this.volumeSlider.val(),false);
        })
        if(this.isChatterLocked() || this.isOtherSpacesVolumeLocked()){
            this.volumeSlider.attr('disabled',true)
        }
        const sliderWrapper=$("<div/>",{
            class:'volume-slider-wrapper',
            html:[this.volumeSlider,this.runnable]
        })
        this.volumeSliderWrapper=sliderWrapper;
        this.applyOtherSpacesVolumeTooltip();

        $("#lobby-volume-slider-content").html([sliderWrapper,"&nbsp;",this.volumePercentage]);
    }

    setVolume(volume,updateSlider=true){
        updateSlider && this.volumeSlider.val(volume);
        if(volume > 0) this.lastVolume=volume;
        this.volume = volume;
        this.updateSliderUI();
        const participants = kinoParticipants.getLobby();
        participants.forEach(p => {
            if(p && !p.local && !onStage.participants.includes(p.id)){
                p.setVolume(volume);
            }else if(onStage.participants.includes(p.id) && p.volume < 1){
                //participant is on stage
                p.setVolume(1);
            }
        })
    }

    unMute(){
        const lastVolume = this.lastVolume ? this.lastVolume : CONV_STORAGE.myConversation ? 0.05 : 1;
        this.setVolume(lastVolume)
    }

    getVolume(){
        return this.volumeSlider.val();
    }
    isChatterLocked(){
        return Video.lockMasterVolume.isLocked() && CONV_STORAGE.myConversation && this.volume == 0
    }
    isOtherSpacesVolumeLocked(){
        return !!CONV_STORAGE.myConversation && !permissions.hasControlSpacesVolume();
    }
    applyOtherSpacesVolumeTooltip(){
        if(!this.volumeSliderWrapper){
            return;
        }
        if(this.isOtherSpacesVolumeLocked()){
            this.volumeSliderWrapper
                .attr('data-toggle','tooltip')
                .attr('data-placement','top')
                .attr('title','You do not have permission to change the volume of other spaces.')
                .attr('data-original-title','You do not have permission to change the volume of other spaces.');
        }else{
            this.volumeSliderWrapper
                .removeAttr('data-toggle')
                .removeAttr('title')
                .removeAttr('data-original-title');
        }
    }
    updateSliderUI(){
        adjustSlider(this.runnable[0],this.volumeSlider.val());
        if(this.isChatterLocked() || this.isOtherSpacesVolumeLocked()){
            this.volumeSlider.attr('disabled',true)
        }else{
            this.volumeSlider.removeAttr('disabled')
        }
        this.applyOtherSpacesVolumeTooltip();
        this.volumePercentage.html(`${Math.floor(this.volumeSlider.val() * 100)}%`)
        if(this.volumeSlider.val() == 0){
            $("#lobby-chatter-btn").html(Video.volumeIconMuted);
        }else{
            $("#lobby-chatter-btn").html(Video.volumeIcon);
        }
    }

    renderParticipantToList(results){
        let participantName = $('<div/>',{
            class: 'participants-user',
            html: [results.name]
        })
        let participants = $('<div/>',{
            class: 'participants-container',
            id: `participant-list-${results.id}`,
            html: participantName
        });

        if($("#side-spaces-drawer").hasClass("spaces-panel-expanded")){
            this.activateTheSearchViewExpanded()
        } else {
            this.activateTheSearchView()
        }

        this.participantsListMenu.append(participants);
    }

    renderNoMatchesFound(){
        let container = $('<div/>', {
            class: 'participants-no-matches-found',
            html: 'No matches found'
        })

        if($("#side-spaces-drawer").hasClass("spaces-panel-expanded")){
            this.activateTheSearchViewExpanded()
        } else {
            this.activateTheSearchView()
        }

        this.participantsListMenu.append(container);
    }

    removeParticipantFromList(id){
        let app = this;
        app.participantsListMenu.find(`#participant-list-${id}`).remove();
        app.participantCount--;
        $("#numberOfParticipants").html(kinoParticipants.count());
        if(kinoParticipants.count() == 1){
            $("#numberOfParticipantsText").html('Participant');
        } else {
            $("#numberOfParticipantsText").html('Participants');
        }
    }

    loopAllSpaces(){
        Object.values(CONV_STORAGE.conversations).forEach(space=>{
            this.allSpaces.push(space)
            try {
            } catch (error) { console.error("[Kino Error] [NewSpacesView]", error); }
        })
    }

    findSpaceByParticipant(participant, spaces) {
        const participantId = participant.id;
        for (const space of spaces) {
          if (space.participants.includes(participantId)) {
            return space
          }
        }
        return null;
    }

    searchFunction(query) {
    const results = [];
    this.loopAllSpaces();
    const spaces = this.allSpaces;
    let participants = kinoParticipants.getParticipants();
    Video.hideParticipantTippyMenus();
    this.participantsListMenu.html('');
    const spaceSet = new Set();
    const queryLower = query.toLowerCase();

    const lounge = "lounge";

    for (let i = 1; i <= lounge.length; i++) {
        if (query.startsWith(lounge.substring(0, i))) {
            const loungeParticipantIds = kinoParticipants.getLobby().map(participant => participant.id);
            const loungeParticipant = {
                name: "Lounge",
                participants: loungeParticipantIds,
            }

            if (!spaceSet.has(loungeParticipant.name)) {
                results.push(loungeParticipant)
                spaceSet.add(loungeParticipant.name)
            }
        }
    }


    spaces.forEach(space => {
        const spaceNameLower = space.name.toLowerCase();
        if (spaceNameLower.indexOf(queryLower) === 0 && !spaceSet.has(space.id)) {
            results.push(space);
            spaceSet.add(space.id);
        }
    });

    participants.forEach(participant => {
        const participantNameLower = participant.name.toLowerCase();
        if (participantNameLower.indexOf(queryLower) === 0) {
            const spaceWithParticipant = this.findSpaceByParticipant(participant, spaces);
            if (spaceWithParticipant) {
                if (!spaceSet.has(spaceWithParticipant.id)) {
                    results.push(spaceWithParticipant);
                    spaceSet.add(spaceWithParticipant.id);
                }
            }
        }
    });

    kinoParticipants.getLobby().forEach(participant => {
        const loungeParticipantIds = kinoParticipants.getLobby().map(participant => participant.id);
        if (participant.name.toLowerCase().indexOf(queryLower) === 0) {
            const lobbyParticipant = {
                name: "Lounge",
                participants: loungeParticipantIds
            }

            if (!spaceSet.has(lobbyParticipant.name)) {
                results.push(lobbyParticipant)
                spaceSet.add(lobbyParticipant.name)
            }
        }
    })
        console.log("results",results);
        this.renderMatchSpaces(results, query);
    }


    renderMatchSpaces(results,query) {
        const addedParticipants = new Set();
        const isExpanded = $("#side-spaces-drawer").hasClass("spaces-panel-expanded")
        results.forEach(space => {
            const spaceColorName = space.name;

            const colorMatchByIndex = (text, query) => {
                const queryLower = query.toLowerCase();
                let result = '';

                for (let i = 0; i < text.length; i++) {
                    const char = text[i];
                    const charLower = char.toLowerCase();
                    const isMatch = charLower === queryLower[i];
                    const isSpace = char === ' ';
                    const spanClass = isMatch ? 'highlighted' : (isSpace ? 'empty-span' : '');

                    result += `<span class="${spanClass}">${char}</span>`;
                }

                return result;
            };

            const coloredSpaceName = colorMatchByIndex(spaceColorName, query);

            const icon = $("<span/>", {
                html: `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.75 1.875C0.75 1.57663 0.868526 1.29048 1.0795 1.0795C1.29048 0.868526 1.57663 0.75 1.875 0.75H4.125C4.42337 0.75 4.70952 0.868526 4.9205 1.0795C5.13147 1.29048 5.25 1.57663 5.25 1.875V4.125C5.25 4.42337 5.13147 4.70952 4.9205 4.9205C4.70952 5.13147 4.42337 5.25 4.125 5.25H1.875C1.57663 5.25 1.29048 5.13147 1.0795 4.9205C0.868526 4.70952 0.75 4.42337 0.75 4.125V1.875ZM1.875 1.5C1.77554 1.5 1.68016 1.53951 1.60984 1.60984C1.53951 1.68016 1.5 1.77554 1.5 1.875V4.125C1.5 4.22446 1.53951 4.31984 1.60984 4.39016C1.68016 4.46049 1.77554 4.5 1.875 4.5H4.125C4.22446 4.5 4.31984 4.46049 4.39016 4.39016C4.46049 4.31984 4.5 4.22446 4.5 4.125V1.875C4.5 1.77554 4.46049 1.68016 4.39016 1.60984C4.31984 1.53951 4.22446 1.5 4.125 1.5H1.875ZM6.75 1.875C6.75 1.57663 6.86853 1.29048 7.0795 1.0795C7.29048 0.868526 7.57663 0.75 7.875 0.75H10.125C10.4234 0.75 10.7095 0.868526 10.9205 1.0795C11.1315 1.29048 11.25 1.57663 11.25 1.875V4.125C11.25 4.42337 11.1315 4.70952 10.9205 4.9205C10.7095 5.13147 10.4234 5.25 10.125 5.25H7.875C7.57663 5.25 7.29048 5.13147 7.0795 4.9205C6.86853 4.70952 6.75 4.42337 6.75 4.125V1.875ZM7.875 1.5C7.77554 1.5 7.68016 1.53951 7.60983 1.60984C7.53951 1.68016 7.5 1.77554 7.5 1.875V4.125C7.5 4.22446 7.53951 4.31984 7.60983 4.39016C7.68016 4.46049 7.77554 4.5 7.875 4.5H10.125C10.2245 4.5 10.3198 4.46049 10.3902 4.39016C10.4605 4.31984 10.5 4.22446 10.5 4.125V1.875C10.5 1.77554 10.4605 1.68016 10.3902 1.60984C10.3198 1.53951 10.2245 1.5 10.125 1.5H7.875ZM0.75 7.875C0.75 7.57663 0.868526 7.29048 1.0795 7.0795C1.29048 6.86853 1.57663 6.75 1.875 6.75H4.125C4.42337 6.75 4.70952 6.86853 4.9205 7.0795C5.13147 7.29048 5.25 7.57663 5.25 7.875V10.125C5.25 10.4234 5.13147 10.7095 4.9205 10.9205C4.70952 11.1315 4.42337 11.25 4.125 11.25H1.875C1.57663 11.25 1.29048 11.1315 1.0795 10.9205C0.868526 10.7095 0.75 10.4234 0.75 10.125V7.875ZM1.875 7.5C1.77554 7.5 1.68016 7.53951 1.60984 7.60983C1.53951 7.68016 1.5 7.77554 1.5 7.875V10.125C1.5 10.2245 1.53951 10.3198 1.60984 10.3902C1.68016 10.4605 1.77554 10.5 1.875 10.5H4.125C4.22446 10.5 4.31984 10.4605 4.39016 10.3902C4.46049 10.3198 4.5 10.2245 4.5 10.125V7.875C4.5 7.77554 4.46049 7.68016 4.39016 7.60983C4.31984 7.53951 4.22446 7.5 4.125 7.5H1.875ZM6.75 7.875C6.75 7.57663 6.86853 7.29048 7.0795 7.0795C7.29048 6.86853 7.57663 6.75 7.875 6.75H10.125C10.4234 6.75 10.7095 6.86853 10.9205 7.0795C11.1315 7.29048 11.25 7.57663 11.25 7.875V10.125C11.25 10.4234 11.1315 10.7095 10.9205 10.9205C10.7095 11.1315 10.4234 11.25 10.125 11.25H7.875C7.57663 11.25 7.29048 11.1315 7.0795 10.9205C6.86853 10.7095 6.75 10.4234 6.75 10.125V7.875ZM7.875 7.5C7.77554 7.5 7.68016 7.53951 7.60983 7.60983C7.53951 7.68016 7.5 7.77554 7.5 7.875V10.125C7.5 10.2245 7.53951 10.3198 7.60983 10.3902C7.68016 10.4605 7.77554 10.5 7.875 10.5H10.125C10.2245 10.5 10.3198 10.4605 10.3902 10.3902C10.4605 10.3198 10.5 10.2245 10.5 10.125V7.875C10.5 7.77554 10.4605 7.68016 10.3902 7.60983C10.3198 7.53951 10.2245 7.5 10.125 7.5H7.875Z" fill="#F7A95D"/>
                </svg>
                `
            })

            const isEnterLoungeHidden = CONV_STORAGE.myConversation === null && space.name === "Lounge"

            const enterSpaceButton = $("<button/>", {
                class: `btn-blur enter-space-button ${CONV_STORAGE.myConversation === space.id ?? "d-none"} ${isEnterLoungeHidden ?? "d-none"}`,
                html: "ENTER"
            }).on("click", () => {
                if(!space.id){
                    CONV_STORAGE.leaveSpace();
                } else {
                    space.onJoinSpace()
                }
                this.searchInput.val("")
                this.searchInput.blur()
                if(isExpanded){
                    this.deactivateTheSearchViewExpanded()
                }else {
                    this.deactivateTheSearchView()
                }
            })

            const spaceEditNameInput = $("<input/>", {
                class: "edit-space-name d-none",
                maxlength: 25,
            }).on("keydown", (e) => {
                if(e.which === 27) {
                    spaceEditNameInput.addClass("d-none")
                    spaceName.removeClass("d-none")
                }
            }).on("keypress", (e) => {
                let code = e.keyCode || e.which;
                if (code == 13) {
                    this.saveSearchSpaceName(spaceEditNameInput,spaceName,space)
                }
            }).on("blur", () => {
                    this.saveSearchSpaceName(spaceEditNameInput,spaceName,space)
            })

            const spaceName = $('<h6/>',{
                class: 'space-name ellipsis',
                id: `space-name-${space.id}`,
                html: coloredSpaceName + `${space.name === "Lounge" ? "" : "'s Space"}`
            }).on("click", () => {
                if (space.id !== CONV_STORAGE.myConversation && !permissions.hasSpacesManager()) {
                    return;
                }
                if (!permissions.hasSpacesManager() && space.conv_type == "pinned") {
                    return;
                }
                spaceEditNameInput.removeClass("d-none")
                spaceName.addClass("d-none")
                spaceEditNameInput.focus()
                spaceEditNameInput.val(space.name)
            }).on("mouseover", () => {
                if (!permissions.isMod()) {
                    spaceName.attr("data-original-title", "You don't have permissions to edit the space name");
                    spaceName.attr("data-placement", "top");
                    spaceName.attr("title", "");
                    spaceName.attr("data-toggle", "tooltip");
                } else {
                    // Remove attributes when in the else block
                    spaceName.removeAttr("data-original-title");
                    spaceName.removeAttr("data-placement");
                    spaceName.removeAttr("title");
                    spaceName.removeAttr("data-toggle");
                }
            })

            if (!space.id) {
                spaceName.attr({
                  "data-original-title": "The name of this Space cannot be changed",
                  "data-placement": "top",
                  "title": "",
                  "data-toggle": "tooltip"
                });
            }

            const leftSideHeader = $('<div/>',{
                class: 'left-side-header',
                html: [icon, spaceName, spaceEditNameInput]
            });

            const rightSideHeader = $('<div/>',{
                class: 'right-side-header',
                html: enterSpaceButton
            });

            const searchResultHeader = $("<div/>", {
                class: "search-result-header",
                html: [leftSideHeader, rightSideHeader]
            })

            const searchResultBody = $("<div/>", {
                class: "search-result-body",
            })

            const spaceBody = $("<div/>", {
                class: "body-layout-conatiner",
                html: searchResultBody
            })
            spaceBody.css("min-height", this.getTileHeight() + "px")

            searchResultBody.empty();
            if(space.participants.length !== 0){
            this.renderParticipants(space,addedParticipants,searchResultBody, query)
            } else {
            this.renderEmptySpace(searchResultBody)
        }

            const searchResultContainer = $('<div/>',{
                class: `${$("#side-spaces-drawer").hasClass("spaces-panel-expanded") ? "search-result-container col-3" : "search-result-container"}`,
                html: [searchResultHeader, spaceBody]
            })

            if($("#side-spaces-drawer").hasClass("spaces-panel-expanded")){
                this.activateTheSearchViewExpanded()
            } else {
                this.activateTheSearchView()
            }

            this.participantsListMenu.append(searchResultContainer);
        });

        if(results.length === 0){
            const noResult = $("<h6/>", {
                html: "No results",
                class: "no-results"
            })
            if($("#side-spaces-drawer").hasClass("spaces-panel-expanded")){
                this.activateTheSearchViewExpanded()
            } else {
                this.activateTheSearchView()
            }
            this.participantsListMenu.append(noResult);
        }
    }

    renderParticipants(space,addedParticipants,searchResultBody, query){
        space.participants.forEach(participant => {
            if (!addedParticipants.has(participant)) {
                const p = kinoParticipants.get(participant);
                const spaceColorName = p.name;

                const colorMatchByIndex = (text, query) => {
                    const queryLower = query.toLowerCase();
                    let result = '';

                    for (let i = 0; i < text.length; i++) {
                        const char = text[i];
                        const charLower = char.toLowerCase();
                        const isMatch = charLower === queryLower[i];
                        const isSpace = char === ' ';
                        const spanClass = isMatch ? 'highlighted' : (isSpace ? 'empty-span' : '');

                        result += `<span class="${spanClass}">${char}</span>`;
                    }

                    return result;
                };

                const coloredSpaceName = colorMatchByIndex(spaceColorName, query);

                const participantName = $("<span/>", {
                    class: "participant-name",
                    html: coloredSpaceName + `${p.local ? "(me)" : ""}`
                });
                const participantAction = $("<span/>", {
                    class: "participant-action",
                    html: `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 426.667 426.667" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><circle cx="42.667" cy="213.333" r="42.667" fill="#ffffff" opacity="1" data-original="#000000" class=""></circle><circle cx="213.333" cy="213.333" r="42.667" fill="#ffffff" opacity="1" data-original="#000000" class=""></circle><circle cx="384" cy="213.333" r="42.667" fill="#ffffff" opacity="1" data-original="#000000" class=""></circle></g></svg>`
                })
                Video.attachParticipantMenuTippy(participantAction[0], p)

                const participantAvatar = $("<div/>", {
                    class: "search-result-avatar",
                    html: (p && p.name && String(p.name).trim().length)
                        ? String(p.name).trim().charAt(0).toUpperCase()
                        : '<svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>'
                })

                const participantHeader = $("<div/>", {
                    class: "participant-header",
                    html: [participantAvatar, participantName, participantAction]
                })

                const participantContainer = $("<div/>", {
                    class: "participant-conatiner",
                    html: [participantHeader]
                })

                searchResultBody.append(participantContainer);
                addedParticipants.add(participant);
            }
        });
    }

    renderEmptySpace(searchResultBody){
        const noParticipantTitle = $("<h6/>", {
            class: "empty-space-title",
            html: "Empty Space"
        });
        searchResultBody.append(noParticipantTitle);
    }

    activateTheSearchView(){
        this.participantsListMenu.removeClass("d-none")
        this.spacesPanelScrollable.addClass("d-none")
        this.backButton.removeClass("d-none")
    }

    deactivateTheSearchView(){
        Video.hideParticipantTippyMenus();
        this.backButton.addClass("d-none")
        this.participantsListMenu.addClass("d-none")
        this.spacesPanelScrollable.removeClass("d-none")
        this.resetSearchInputs()
    }

    activateTheSearchViewExpanded(){
        this.backButtonExpandedView.removeClass("d-none")
        this.participantsListMenu.removeClass("d-none")
        this.spacesPanelScrollable.addClass("d-none").removeClass("d-flex")
        this.participantsListMenu.addClass("d-flex")
    }

    deactivateTheSearchViewExpanded(){
        Video.hideParticipantTippyMenus();
        this.backButtonExpandedView.addClass("d-none")
        this.participantsListMenu.addClass("d-none")
        this.spacesPanelScrollable.removeClass("d-none").addClass("d-flex")
        this.participantsListMenu.removeClass("d-flex")
        this.resetSearchInputs()
    }

    resetSearchInputs(){
        this.searchInput.val("")
        this.searchBarInputExpandedView.val("")
        this.clearSearch.addClass("d-none")
        this.clearSearchExpandedView.addClass("d-none")
        this.participantsListMenu.html("")
    }

    showAllSpacesInList() {
        this.loopAllSpaces();
        const spaces = this.allSpaces;
        const uniqueSpaceNames = new Set();
        const results = [
            {
                name: "Lounge",
                participants: kinoParticipants.getLobby().map(participant => participant.id)
            },
            ...spaces.filter(space => {
                if (!uniqueSpaceNames.has(space.id)) {
                    uniqueSpaceNames.add(space.id);
                    return true;
                }
                return false;
            })
        ];
        Video.hideParticipantTippyMenus();
        this.participantsListMenu.html("")
        this.renderAllSpacesInList(results);
    }



    renderAllSpacesInList(results){
        const addedParticipants = new Set();
        const isExpanded = $("#side-spaces-drawer").hasClass("spaces-panel-expanded")
        results.map(space => {
            const icon = $("<span/>", {
                html: `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.75 1.875C0.75 1.57663 0.868526 1.29048 1.0795 1.0795C1.29048 0.868526 1.57663 0.75 1.875 0.75H4.125C4.42337 0.75 4.70952 0.868526 4.9205 1.0795C5.13147 1.29048 5.25 1.57663 5.25 1.875V4.125C5.25 4.42337 5.13147 4.70952 4.9205 4.9205C4.70952 5.13147 4.42337 5.25 4.125 5.25H1.875C1.57663 5.25 1.29048 5.13147 1.0795 4.9205C0.868526 4.70952 0.75 4.42337 0.75 4.125V1.875ZM1.875 1.5C1.77554 1.5 1.68016 1.53951 1.60984 1.60984C1.53951 1.68016 1.5 1.77554 1.5 1.875V4.125C1.5 4.22446 1.53951 4.31984 1.60984 4.39016C1.68016 4.46049 1.77554 4.5 1.875 4.5H4.125C4.22446 4.5 4.31984 4.46049 4.39016 4.39016C4.46049 4.31984 4.5 4.22446 4.5 4.125V1.875C4.5 1.77554 4.46049 1.68016 4.39016 1.60984C4.31984 1.53951 4.22446 1.5 4.125 1.5H1.875ZM6.75 1.875C6.75 1.57663 6.86853 1.29048 7.0795 1.0795C7.29048 0.868526 7.57663 0.75 7.875 0.75H10.125C10.4234 0.75 10.7095 0.868526 10.9205 1.0795C11.1315 1.29048 11.25 1.57663 11.25 1.875V4.125C11.25 4.42337 11.1315 4.70952 10.9205 4.9205C10.7095 5.13147 10.4234 5.25 10.125 5.25H7.875C7.57663 5.25 7.29048 5.13147 7.0795 4.9205C6.86853 4.70952 6.75 4.42337 6.75 4.125V1.875ZM7.875 1.5C7.77554 1.5 7.68016 1.53951 7.60983 1.60984C7.53951 1.68016 7.5 1.77554 7.5 1.875V4.125C7.5 4.22446 7.53951 4.31984 7.60983 4.39016C7.68016 4.46049 7.77554 4.5 7.875 4.5H10.125C10.2245 4.5 10.3198 4.46049 10.3902 4.39016C10.4605 4.31984 10.5 4.22446 10.5 4.125V1.875C10.5 1.77554 10.4605 1.68016 10.3902 1.60984C10.3198 1.53951 10.2245 1.5 10.125 1.5H7.875ZM0.75 7.875C0.75 7.57663 0.868526 7.29048 1.0795 7.0795C1.29048 6.86853 1.57663 6.75 1.875 6.75H4.125C4.42337 6.75 4.70952 6.86853 4.9205 7.0795C5.13147 7.29048 5.25 7.57663 5.25 7.875V10.125C5.25 10.4234 5.13147 10.7095 4.9205 10.9205C4.70952 11.1315 4.42337 11.25 4.125 11.25H1.875C1.57663 11.25 1.29048 11.1315 1.0795 10.9205C0.868526 10.7095 0.75 10.4234 0.75 10.125V7.875ZM1.875 7.5C1.77554 7.5 1.68016 7.53951 1.60984 7.60983C1.53951 7.68016 1.5 7.77554 1.5 7.875V10.125C1.5 10.2245 1.53951 10.3198 1.60984 10.3902C1.68016 10.4605 1.77554 10.5 1.875 10.5H4.125C4.22446 10.5 4.31984 10.4605 4.39016 10.3902C4.46049 10.3198 4.5 10.2245 4.5 10.125V7.875C4.5 7.77554 4.46049 7.68016 4.39016 7.60983C4.31984 7.53951 4.22446 7.5 4.125 7.5H1.875ZM6.75 7.875C6.75 7.57663 6.86853 7.29048 7.0795 7.0795C7.29048 6.86853 7.57663 6.75 7.875 6.75H10.125C10.4234 6.75 10.7095 6.86853 10.9205 7.0795C11.1315 7.29048 11.25 7.57663 11.25 7.875V10.125C11.25 10.4234 11.1315 10.7095 10.9205 10.9205C10.7095 11.1315 10.4234 11.25 10.125 11.25H7.875C7.57663 11.25 7.29048 11.1315 7.0795 10.9205C6.86853 10.7095 6.75 10.4234 6.75 10.125V7.875ZM7.875 7.5C7.77554 7.5 7.68016 7.53951 7.60983 7.60983C7.53951 7.68016 7.5 7.77554 7.5 7.875V10.125C7.5 10.2245 7.53951 10.3198 7.60983 10.3902C7.68016 10.4605 7.77554 10.5 7.875 10.5H10.125C10.2245 10.5 10.3198 10.4605 10.3902 10.3902C10.4605 10.3198 10.5 10.2245 10.5 10.125V7.875C10.5 7.77554 10.4605 7.68016 10.3902 7.60983C10.3198 7.53951 10.2245 7.5 10.125 7.5H7.875Z" fill="#F7A95D"/>
                </svg>
                `
            })

            const isEnterLoungeHidden = CONV_STORAGE.myConversation === null && space.name === "Lounge"

            const enterSpaceButton = $("<button/>", {
                class: `btn-blur enter-space-button ${CONV_STORAGE.myConversation === space.id ?? "d-none"} ${isEnterLoungeHidden ?? "d-none"}`,
                html: "ENTER"
            }).on("click", () => {
                if(!space.id){
                    CONV_STORAGE.leaveSpace();
                } else {
                    space.onJoinSpace()
                }
                this.searchInput.val("")
                this.searchInput.blur()
                if(isExpanded){
                    this.deactivateTheSearchViewExpanded()
                }else {
                    this.deactivateTheSearchView()
                }
            })



            const spaceEditNameInput = $("<input/>", {
                class: "edit-space-name d-none",
                maxlength: 25,
            }).on("keydown", (e) => {
                if(e.which === 27) {
                    spaceEditNameInput.addClass("d-none")
                    spaceName.removeClass("d-none")
                }
            }).on("keypress", (e) => {
                let code = e.keyCode || e.which;
                if (code == 13) {
                    this.saveSearchSpaceName(spaceEditNameInput,spaceName,space)
                }
            }).on("blur", () => {
                    this.saveSearchSpaceName(spaceEditNameInput,spaceName,space)
            })

            const spaceName = $('<h6/>',{
                class: 'space-name ellipsis',
                id: `space-name-${space.id}`,
                html: space.name + `${space.name === "Lounge" ? "" : "'s Space"}`,
            }).on("click", () => {
                if (space.id !== CONV_STORAGE.myConversation && !permissions.hasSpacesManager()) {
                    return;
                }
                if (!permissions.hasSpacesManager() && space.conv_type == "pinned") {
                    return;
                }
                spaceEditNameInput.removeClass("d-none")
                spaceName.addClass("d-none")
                spaceEditNameInput.focus()
                spaceEditNameInput.val(space.name)

            }).on("mouseover", () => {
                if (!permissions.isMod()) {
                    spaceName.attr("data-original-title", "You don't have permissions to edit the space name");
                    spaceName.attr("data-placement", "top");
                    spaceName.attr("title", "");
                    spaceName.attr("data-toggle", "tooltip");
                } else {
                    // Remove attributes when in the else block
                    spaceName.removeAttr("data-original-title");
                    spaceName.removeAttr("data-placement");
                    spaceName.removeAttr("title");
                    spaceName.removeAttr("data-toggle");
                }
            })

            if (!space.id) {
                spaceName.attr({
                  "data-original-title": "The name of this Space cannot be changed",
                  "data-placement": "top",
                  "title": "",
                  "data-toggle": "tooltip"
                });
            }


            const leftSideHeader = $('<div/>',{
                class: 'left-side-header',
                html: [icon, spaceName, spaceEditNameInput]
            });

            const rightSideHeader = $('<div/>',{
                class: 'right-side-header',
                html: enterSpaceButton
            });

            const searchResultHeader = $("<div/>", {
                class: "search-result-header",
                html: [leftSideHeader, rightSideHeader]
            })

            const searchResultBody = $("<div/>", {
                class: "search-result-body",
            })

            const spaceBody = $("<div/>", {
                class: "body-layout-conatiner",
                html: searchResultBody
            })
            spaceBody.css("min-height", this.getTileHeight() + "px")

            searchResultBody.empty();
            if(space.participants.length !== 0){
            this.renderParticipantsForAllSpaces(space,addedParticipants,searchResultBody)
            } else {
            this.renderEmptySpace(searchResultBody)
        }

            const searchResultContainer = $('<div/>',{
                class: `${$("#side-spaces-drawer").hasClass("spaces-panel-expanded") ? "search-result-container col-3" : "search-result-container"}`,
                html: [searchResultHeader, spaceBody]
            })

            if($("#side-spaces-drawer").hasClass("spaces-panel-expanded")){
                this.activateTheSearchViewExpanded()
            } else {
                this.activateTheSearchView()
            }

            this.participantsListMenu.append(searchResultContainer);
        });

        if(results.length === 0){
            const noResult = $("<h6/>", {
                html: "No results",
                class: "no-results"
            })
            if($("#side-spaces-drawer").hasClass("spaces-panel-expanded")){
                this.activateTheSearchViewExpanded()
            } else {
                this.activateTheSearchView()
            }
            this.participantsListMenu.append(noResult);
        }
    }

    renderParticipantsForAllSpaces(space,addedParticipants,searchResultBody, query){
        space.participants.forEach(participant => {
            if (!addedParticipants.has(participant)) {
                const p = kinoParticipants.get(participant);

                const participantName = $("<h6/>", {
                    class: "participant-name ellipsis",
                    html: p.name + `${p.local ? "(me)" : ""}`
                })
                const participantAction = $("<span/>", {
                    class: "participant-action",
                    html: `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 426.667 426.667" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><circle cx="42.667" cy="213.333" r="42.667" fill="#ffffff" opacity="1" data-original="#000000" class=""></circle><circle cx="213.333" cy="213.333" r="42.667" fill="#ffffff" opacity="1" data-original="#000000" class=""></circle><circle cx="384" cy="213.333" r="42.667" fill="#ffffff" opacity="1" data-original="#000000" class=""></circle></g></svg>`
                })
                Video.attachParticipantMenuTippy(participantAction[0], p)

                const participantAvatar = $("<div/>", {
                    class: "search-result-avatar",
                    html: (p && p.name && String(p.name).trim().length)
                        ? String(p.name).trim().charAt(0).toUpperCase()
                        : '<svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>'
                })

                const participantHeader = $("<div/>", {
                    class: "participant-header",
                    html: [participantAvatar, participantName, participantAction]
                })

                const participantContainer = $("<div/>", {
                    class: "participant-conatiner",
                    html: [participantHeader]
                })

                searchResultBody.append(participantContainer);
                addedParticipants.add(participant);
            }
        });
    }

    expandLobbyHeight() {
        this.lobbyTiles.addClass("full-height-space");
        $("#loungeTitle").html("Stage View")
        this.renderLobbySpaceTiles();
    }



    collapseLobbyHeight() {
        this.lobbyTiles.removeClass("full-height-space");
        $("#loungeTitle").html("Lounge")
        this.renderLobbySpaceTiles();
    }

    ///// Edit Space Name Functions

    saveSearchSpaceName(spaceEditNameInput,spaceName, space) {
        let conv_name = spaceEditNameInput.val()
        if (conv_name == "" || !conv_name.trim().length) {
            conv_name = "Pinned Space";
        }

        let santize_conv_name = sanitizeHtml(conv_name, this.sanitizeOptions)

        space.saveName(santize_conv_name)
        if (permissions.hasSpacesManager() ||  CONV_STORAGE.myConversation == space.id) {
            spaceName.html(santize_conv_name + (spaceName === "Lounge" ? "" : "'s Space"));
            spaceName.removeClass("d-none")
            spaceEditNameInput.addClass("d-none")
        } else {
            spaceName.removeClass("d-none")
            spaceEditNameInput.addClass("d-none")
        }
    };

    generateSpaceName() {
        const index = Object.keys(CONV_STORAGE.conversations).length + 1;
        return "Space "+index
    }
    createNewSpace(){
        CONV_STORAGE.createPinnedConversation(this.generateSpaceName()).then((space)=>{
            console.log("space created")
            space.setSpaceOrder(1)
            space.makeNameEditable();
        })
    }

    inviteOver(participant){
        //lock focus
        if(lockFocus.isLocked() && !permissions.hasSpacesLock()){
            lockFocus.showLockFocusNotification();
            return;
        }

        let DISPLAY_OPTION=false;
        let cid=false;
         /**Do conversation check */
        if(onStage.myStage.isStageView()){
            onStage.showLockOnStageActiveNotification();
            return;
        }else if(onStage.isActive()){
            onStage.showLockOnStageActiveNotification();
            return;
        }

        if(kinoParticipants.isInMySpace(participant)){
            //participant already in my space
            CONV_STORAGE.showInviteOrLeave(participant);
            return
        }

        cid=CONV_STORAGE.isOnConversation(participant);
        if(cid){
            if(CONV_STORAGE.myConversation > 0){
                //both participants are on a conversation
                if(cid != CONV_STORAGE.myConversation){
                    //participants are in different conversations
                    //option to leave conversation and focus on other conversation
                    DISPLAY_OPTION="JUMP_TO_OTHER_CONVO";
                }else{
                    DISPLAY_OPTION="INVITE_OR_LEAVE";
                }
            }else{
                //I am not on a conversation
                //show option to join this conversation
                DISPLAY_OPTION="JOIN_CONVERSATION";
            }
        }else{
            //not in a conversation
            if(CONV_STORAGE.myConversation > 0){
                //invite to join conversation or drop this conversation and focus on participant
                DISPLAY_OPTION="JOIN_CONVERSATION";
            }else{
                DISPLAY_OPTION="INVITE_TO_NEW_SPACE";
            }
        }

        if(DISPLAY_OPTION){
            //do stuff based on option
            CONV_STORAGE.showNotification(Video.conversationIcon,DISPLAY_OPTION,{participant:participant,displayName:Video.videos[participant].displayName,conversation_id:cid});
            //alert("Display this option to participant: "+DISPLAY_OPTION);
            return;
        }
    }


    orderSpacesByNameAndPinned() {
        const spaces = Object.values(CONV_STORAGE.conversations);
        const pinnedSpaces = spaces.filter(space => space.pinned);
        const nonPinnedSpaces = spaces.filter(space => !space.pinned);

        pinnedSpaces.sort((spaceA, spaceB) => spaceA.name.localeCompare(spaceB.name));
        nonPinnedSpaces.sort((spaceA, spaceB) => spaceA.name.localeCompare(spaceB.name));
        if(pinnedSpaces && pinnedSpaces.length > 0){
            let startOrder =this.pinnedSpacesOrderStart
            for(let i = 0; i < pinnedSpaces.length; i++){
                pinnedSpaces[i].setSpaceOrder(startOrder+i);
            }
        }

        if(nonPinnedSpaces && nonPinnedSpaces.length > 0){
            let startOrder =this.nonPinnedSpacesOrderStart
            for(let i = 0; i < nonPinnedSpaces.length; i++){
                nonPinnedSpaces[i].setSpaceOrder(startOrder+i);
            }
        }
    }

    orderPinnedSpaces(){
        const pinnedSpaces = Object.values(CONV_STORAGE.conversations).filter(space => space.pinned);
        pinnedSpaces.sort((spaceA, spaceB) => spaceA.name.localeCompare(spaceB.name));
        if(pinnedSpaces && pinnedSpaces.length > 0){
            let startOrder =this.pinnedSpacesOrderStart
            for(let i = 0; i < pinnedSpaces.length; i++){
                pinnedSpaces[i].setSpaceOrder(startOrder+i);
            }
        }
    }

    orderNonPinnedSpaces(){
        console.log("orderNonPinnedSpaces");
        const nonPinnedSpaces = Object.values(CONV_STORAGE.conversations).filter(space => !space.pinned);
        nonPinnedSpaces.sort((spaceA, spaceB) => spaceA.name.localeCompare(spaceB.name));
        if(nonPinnedSpaces && nonPinnedSpaces.length > 0){
            let startOrder =this.nonPinnedSpacesOrderStart
            for(let i = 0; i < nonPinnedSpaces.length; i++){
                nonPinnedSpaces[i].setSpaceOrder(startOrder+i);
            }
        }
    }
}
